const debug = false

module.exports = debug